// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__36QYT","content":"styles_content__1vblA","row":"styles_row__2VXRj","footer":"styles_footer__3LfgJ","phraseLength":"styles_phraseLength__1OZ9O"};